// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import './CSS/Global.css'
import Home from "./Components/Home";
import Header from "./Components/Header";
import Enquiry from "./Components/Enquiry";
import Contact from "./Components/Contact";
import Footer from "./Components/Footer";
import About from "./Components/About";
import EnquiryDrawerForm from "./Components/EnquiryFormDrawer";
import ScrollToTop from "./Components/ScrollToTop";
import { ToastContainer } from "react-toastify";
import HomeIndustries from "./Components/HomeIndustry";
import IndustriesServedPage from "./Components/IndustriesServedPage";
import TermsAndConditions from "./Components/TermsAndConditions";
import PrivacyPolicy from "./Components/PrivacyPolicy";

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/industries-served" element={<IndustriesServedPage />} />
        <Route path="/Terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
      <EnquiryDrawerForm />
      <Footer />
      <ToastContainer />
    </>
  );
}

export default App;
